import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import { DesktopAndTablet, Mobile } from '../../Utils/MediaComponents/MediaComponents.tsx';
import tracking from '../../../tracking/tracking.js';
import { appendSearchParamsFromQuery } from '../../../utils/urlUtils.js';
import styles from '../Header.less';
import { getLocationOrigin, getLocationQuery } from "../../../selectors/selectors";

const isCityState = (node) => node.link === '/orte/deutschland/berlin' || node.link === '/orte/deutschland/hamburg';

function getJsonLd(items, locationOrigin) {
  // https://schema.org/BreadcrumbList#jsonld
  const data = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items
      .filter((node, index) => index !== items.length - 1)
      .map((item, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@id': `${locationOrigin}${item.link}`,
          name: item.name,
        },
      })),
  };

  return JSON.stringify(data);
}

export class HeaderBreadcrumb extends React.Component {
  constructor(props) {
    super(props);
  }

  onClickHandler = (event, breadcrumbItem) => {
    const { locationQuery } = this.props;

    event.preventDefault();
    tracking
      .report(`breadcrumb_${breadcrumbItem.level}`)
      .then(() => window.open(`${appendSearchParamsFromQuery(breadcrumbItem.link, locationQuery)}`, '_self'));
  };

  render() {
    const { hierarchyLevel, breadcrumbItems, locationQuery, locationOrigin } = this.props;
    if (!breadcrumbItems || breadcrumbItems.length === 0) {
      return null;
    }

    const items = hierarchyLevel === 'region' ? breadcrumbItems : breadcrumbItems.filter((node) => !isCityState(node));

    return (
      <>
        <DesktopAndTablet
          render={() => (
            <div className="align-center padding-top-l">
              <ul className={styles.breadcrumbList}>
                {items.map((item, index) => {
                  if (index === items.length - 1) {
                    return (
                      <li key={`breadcrumb-${item.level}`}>
                        <span id={`breadcrumb-${item.level}`}>{item.name || items[index - 1].name}</span>
                      </li>
                    );
                  }
                  return (
                    <li key={`breadcrumb-${item.level}`}>
                      <a
                        id={`breadcrumb-${item.level}`}
                        className={`breadcrumb-${item.level}`}
                        href={`${appendSearchParamsFromQuery(item.link, locationQuery)}`}
                        target="_self"
                        onClick={(event) => {
                          this.onClickHandler(event, item);
                        }}
                      >
                        {item.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
              <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: getJsonLd(items, locationOrigin) }} />
            </div>
          )}
        />
        <Mobile
          render={() => {
            const itemMobile = items[items.length - 2];
            return (
              <div className={`align-left ${styles.breadcrumb}`}>
                <div className={styles.breadcrumbList}>
                  <a
                    id={`breadcrumb-${itemMobile.level}`}
                    className={`breadcrumb-${itemMobile.level}`}
                    href={`${appendSearchParamsFromQuery(itemMobile.link, locationQuery)}`}
                    target="_self"
                    onClick={(event) => {
                      this.onClickHandler(event, itemMobile);
                    }}
                  >
                    {itemMobile.name}
                  </a>
                </div>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: getJsonLd(items, locationOrigin) }} />
              </div>
            );
          }}
        />
      </>
    );
  }
}

HeaderBreadcrumb.defaultProps = {
  breadcrumbItems: [],
};

const BreadcrumbItem = PropTypes.shape({
  level: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
});

HeaderBreadcrumb.propTypes = {
  breadcrumbItems: PropTypes.arrayOf(BreadcrumbItem),
  hierarchyLevel: PropTypes.string.isRequired,
  locationQuery: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  locationQuery: getLocationQuery(state),
  locationOrigin: getLocationOrigin(state),
});

export default connect(mapStateToProps)(HeaderBreadcrumb);
